import { useMemo } from "react";
import { DayPickerProps } from "react-day-picker";

interface UseDayShadeModifiersArgs {
  isDayDisabled: (d: Date) => boolean;
  isOutsideMaxRangeWindow: (d: Date) => boolean;
}

export function useDayShadeModifiers({
  isDayDisabled,
  isOutsideMaxRangeWindow,
}: UseDayShadeModifiersArgs) {
  return useMemo(() => {
    const modifiers: DayPickerProps["modifiers"] = {
      shadeDisabled: (d) => isDayDisabled(d),
      shadeOutOfRange: (d) => !isDayDisabled(d) && isOutsideMaxRangeWindow(d),
    };

    const modifiersClassNames: DayPickerProps["modifiersClassNames"] = {
      shadeDisabled: "text-muted-foreground opacity-20",
      shadeOutOfRange: "text-muted-foreground opacity-60",
    };

    return { modifiers, modifiersClassNames };
  }, [isDayDisabled, isOutsideMaxRangeWindow]);
}
